class PaylocityPayrollDetailCodes {
  constructor($rootScope, $http, toastr) {
    "ngInject";
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.toastr = toastr;

    this.codes = [];
    this.newCode = '';
    this.newCodeKind = 'DEDUCTION';
    this.codeKinds = [
      { value: 'EARNING', label: 'Earning' },
      { value: 'DEDUCTION', label: 'Deduction' },
      { value: 'TAX', label: 'Tax' }
    ];
    this.loading = true;
    this.saving = false;
    this.dirty = false;

    this.loadCodes();
  }

  apiUrl() {
    return this.$rootScope.apiHost + '/api/integrations/paylocity/payroll-detail-codes';
  }

  loadCodes() {
    let self = this;
    this.loading = true;
    this.$http.get(this.apiUrl(), {withCredentials: true})
      .then(function (res) {
        self.codes = self.normalizeList(res.data && res.data.codes);
        self.dirty = false;
      })
      .catch(function () {
        self.toastr.error('Failed to load payroll detail codes.');
      })
      .finally(function () {
        self.loading = false;
      });
  }

  normalizeList(codes) {
    return (codes || []).map(function (item) {
      return {
        code: item.code,
        codeKind: item.codeKind || 'DEDUCTION',
        description: item.description || '',
        employerResponsible: !!item.employerResponsible,
        fsaExpense: !!item.fsaExpense,
        hsaExpense: !!item.hsaExpense,
        retirementExpense: !!item.retirementExpense
      };
    });
  }

  normalizeCode(code) {
    return (code || '').trim().toUpperCase();
  }

  markDirty() {
    this.dirty = true;
  }

  kindLabel(codeKind) {
    let match = this.codeKinds.find(function (kind) {
      return kind.value === codeKind;
    });
    return match ? match.label : (codeKind || '');
  }

  addCode() {
    let code = this.normalizeCode(this.newCode);
    let kind = this.newCodeKind || 'DEDUCTION';
    if (!code) {
      this.toastr.warning('Enter a detail code to add.');
      return;
    }
    let exists = this.codes.some(function (row) {
      return row.code === code && row.codeKind === kind;
    });
    if (exists) {
      this.toastr.warning(code + ' (' + kind + ') is already in the list.');
      return;
    }
    this.codes.push({
      code: code,
      codeKind: kind,
      description: '',
      employerResponsible: false,
      fsaExpense: false,
      hsaExpense: false,
      retirementExpense: false
    });
    this.sortCodes();
    this.newCode = '';
    this.dirty = true;
  }

  removeCode(row) {
    this.codes = this.codes.filter(function (item) {
      return !(item.code === row.code && item.codeKind === row.codeKind);
    });
    this.dirty = true;
  }

  sortCodes() {
    this.codes.sort(function (a, b) {
      let codeCmp = (a.code || '').localeCompare(b.code || '');
      if (codeCmp !== 0) {
        return codeCmp;
      }
      return (a.codeKind || '').localeCompare(b.codeKind || '');
    });
  }

  save() {
    let self = this;
    this.saving = true;
    this.$http.put(this.apiUrl(), { codes: this.codes }, { withCredentials: true })
      .then(function (res) {
        self.codes = self.normalizeList(res.data && res.data.codes);
        self.dirty = false;
        self.toastr.success('Payroll detail codes saved.');
      })
      .catch(function () {
        self.toastr.error('Failed to save payroll detail codes.');
      })
      .finally(function () {
        self.saving = false;
      });
  }
}

export default PaylocityPayrollDetailCodes;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/payroll-detail-codes/paylocity-payroll-detail-codes.controller.js